export const COUNTRIES__FETCH = 'COUNTRIES__FETCH';
export const COUNTRIES__FETCH_SUCCESS = 'COUNTRIES__FETCH_SUCCESS';
export const COUNTRIES__FETCH_FAILURE = 'COUNTRIES__FETCH_FAILURE';
export const fetch = () => ({ type: COUNTRIES__FETCH });
